export default __webpack_public_path__ + "static/media/P620_CoC.9e06fbb3.pdf";